<!-- <div class="error-box">
  <div class="error-body text-center">
    <h1 class="error-title text-warning">403</h1>
    <h3 class="text-uppercase error-subtitle">ACCESO NO AUTORIZADO</h3>
    <p class="text-muted mt-4 mb-4">
      No tienes permisos para ver esta página.
    </p>
    <a [href]="ruta" class="btn btn-danger btn-rounded waves-effect waves-light mb-4"
      style="padding: 22px 50px; font-size: 22px; font-weight: bold; width: 260px;">
      Regresar
    </a>

  </div>
</div> -->

<div class="error-box">
  <div class="error-overlay"></div>

  <div class="error-layout">
    <div class="error-image" aria-hidden="true"></div>

    <div class="error-body text-center">
      <h1 class="error-title text-warning">403</h1>
      <h3 class="text-uppercase error-subtitle">ACCESO NO AUTORIZADO</h3>
      <p class="error-text">NO TIENES PERMISOS PARA VER ESTA PÁGINA</p>

        <a class="error-btn" (click)="goHome()">
            Regresar
        </a>
    </div>
  </div>
</div>
